// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__AUZRx","container":"LayoutSideNavigation_container__3xl7M","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__3_h6t"};